import React, {Component} from 'react'
import ClientSideCacheController from '../ClientSideCacheController'
import Cannonicalize from '../Cannonicalize'
//great docs at http://digital.wsi.com/products/v3.1/developer_trafficmap.php#wxconfig
class TrafficPage extends Component {
  constructor(props) {
    super(props)
    this.affiliate = props.affiliate
    this.secondsTillUpdate = 30
    this.state = Cannonicalize.traffic()
    this.mapScriptEl = null
    this.trafficMapContainer = null
    this.config = props.affiliate === 'kwtv'
    ? {
        cid : '861739746',
        memberid: '1356',
        mapid: '0001'
      }
    : {
        cid : '469133855',
        memberid: '1357',
        mapid: '0001'
      }
    this.center = props.affiliate === 'kwtv'
      ? {
        lat: 35.4899103,
        lng: -97.5421547
      }
      : {
        lat: 36.153142,
        lng: -95.991567
      }
  }

  componentWillMount() {
    try {
      this.setState(Cannonicalize.traffic(this.props.FRN_rawResponses[0].data))
    } catch (e) {
      console.warn('Illegitimate FRN_rawResponses in Traffic Page', e)
    }
    if (typeof window !== 'object')
      return

    ClientSideCacheController.setAffiliate(this.props.affiliate)
    ClientSideCacheController.get('traffic', {affiliate: this.affiliate}).then((res) => {
      this.setState(res)
    })
  }

  componentDidMount() {

    // this.mapScriptEl = document.createElement('script')
    // this.mapScriptEl.setAttribute('src', `https://widgets.media.weather.com/wxwidget.loader.js?cid=${this.config.cid}`)
    // this.trafficMapContainer.appendChild(this.mapScriptEl)
  }

  severityClass(d) {
    switch (d.severity) {
      case 1:
        return 'icon traffic-status-good';
      case 2:
        return 'icon traffic-status-caution';
      case 3:
        return 'icon traffic-status-alert';
      case 4:
        return 'icon traffic-status-avoid';
      default:
        return 'icon traffic-status-caution';
    }

  }

  render() {
    let lastUpdated = Math.round((Date.now() - this.state.timestamp) / (1000 * 60))
    lastUpdated = lastUpdated > 59
      ? 'Over an hour Ago'
      : lastUpdated + ' min ago'
    return (<div className='gnm-traffic-page '>
      <h1 style={{
          display: 'none'
        }}>Traffic Conditions</h1>
      <h2 className='h5'>{this.state.currentTab}
        <span className='small last-updated'>Updated
          <time dateTime='2015-03-27 10:00'>
            {lastUpdated}</time>
        </span>
      </h2>
      <div className='tab-interface'>

        <ul className='nav nav-tabs sticky' role='tablist'>
          <li role='presentation' className={this.state.currentTab === 'Traffic Map'
              ? 'active'
              : null} onClick={() => {
              this.setState({currentTab: 'Traffic Map'})
            }}>
            <button type='button' role='tab' tabIndex='0' aria-controls='traffic-map' aria-selected='true' className='traffic-tab'>
              <span className='fa fa-map' aria-hidden='true'></span>
              <span className='traffic-tab-text'>Traffic Map</span>
            </button>
          </li>
          <li role='presentation' className={this.state.currentTab === 'Drive Times'
              ? 'active'
              : ''} onClick={() => {
              this.setState({currentTab: 'Drive Times'})
            }}>
            <button type='button' role='tab' aria-controls='profile' className='traffic-tab'>
              <span className='fa fa-car' aria-hidden='true'></span>
              <span className='traffic-tab-text'>Drive Times</span>
            </button>
          </li>
          <li role='presentation' className={this.state.currentTab === 'Incidents'
              ? 'active'
              : ''} onClick={() => {
              this.setState({currentTab: 'Incidents'})
            }}>
            <button type='button' role='tab' aria-controls='messages' className='traffic-tab'>
              <span className='fa fa-ambulance' aria-hidden='true'></span>
              <span className='traffic-tab-text'>Incidents</span>
            </button>
          </li>
          <li role='presentation' className={this.state.currentTab === 'Construction'
              ? 'active'
              : ''} onClick={() => {
              this.setState({currentTab: 'Construction'})
            }}>
            <button type='button' role='tab' aria-controls='settings' className='traffic-tab'>
              <span className='fa fa-road' aria-hidden='true'></span>
              <span className='traffic-tab-text'>Construction</span>
            </button>
          </li>
        </ul>

        <div className='well well-sm traffic-legend-container sticky' role='complementary' aria-hidden='true' style={{
            display: this.state.currentTab === 'Traffic Map'
              ? 'none'
              : 'block'
          }}>
          <ul className='traffic-legend-list'>
            <li className='traffic-legend-list-item'>
              <span className='icon traffic-status-good'></span>Good</li>
            <li className='traffic-legend-list-item'>
              <span className='icon traffic-status-caution'></span>Caution</li>
            <li className='traffic-legend-list-item'>
              <span className='icon traffic-status-alert'></span>Alert</li>
            <li className='traffic-legend-list-item'>
              <span className='icon traffic-status-avoid'></span>Avoid</li>
          </ul>
        </div>

        <div className='tab-content'>
          <section role='tabpanel' className={'tab-pane ' + (
              this.state.currentTab === 'Traffic Map'
              ? 'fade in active'
              : '')}>

            <div className='traffic-map-container' style={{
                height: '540px'
              }} ref={(e) => {this.trafficMapContainer = e}} dangerouslySetInnerHTML={{
                __html: `<wx-widget type="map" menuitems="2001,2002" memberid="${this.config.memberid}" mapid="${this.config.mapid}" fullscreen="true" zoomlevel="11" language="en" latitude="${this.center.lat}" longitude="${this.center.lng}"></wx-widget>
              <script type="text/javascript"  src="https://widgets.media.weather.com/wxwidget.loader.js?cid=${this.config.cid}"></script>`
              }}></div>
          </section>
          <section role='tabpanel' className={'tab-pane ' + (
              this.state.currentTab === 'Drive Times'
              ? 'fade in active'
              : '')}>
            <div className='panel-group' role='tablist' aria-multiselectable='true'>
              {
                this.state.driveTimes.map((d, i, a) => {
                  return (<div className='panel panel-default' key={i}>
                    <button tabIndex='0' type='button' className={'panel-heading accordion-toggle ' + (
                        d.collapsed
                        ? 'collapsed'
                        : '')} role='tab' onClick={() => {
                        var n = this.state.driveTimes;
                        n[i].collapsed = !n[i].collapsed;
                        this.setState({driveTimes: n})
                      }}>
                      <div className='panel-title'>
                        <span className={this.severityClass(d)}>
                          <span className='sr-only'>{d.severity}</span>
                        </span>
                        <span className='traffic-route'>{d.name}</span>
                      </div>
                    </button>
                    <div className={'panel-collapse collapse ' + (
                        d.collapsed
                        ? ''
                        : 'in')} role='tabpanel'>
                      <div className='panel-body'>
                        <dl className='traffic-times-list traffic-times-list'>
                          <dt className='term'>Travel time</dt>
                          <dd className='definition'>{d.minutes}
                            min at {d.speed}
                            mph</dd>
                          <dt className='term'>Distance</dt>
                          <dd className='definition'>{d.length}
                            mi</dd>
                        </dl>
                      </div>
                    </div>
                  </div>)
                })
              }

            </div>
          </section>

          <section role='tabpanel' className={'tab-pane ' + (
              this.state.currentTab === 'Incidents'
              ? 'fade in active'
              : '')}>
            <div className='panel-group' role='tablist' aria-multiselectable='true'>
              {
                this.state.incidents.map((incident, i, a) => {

                  return (<div className='panel panel-default' key={i}>
                    <button tabIndex='0' type='button' className={'panel-heading accordion-toggle ' + (
                        incident.collapsed
                        ? 'collapsed'
                        : '')} role='tab' onClick={() => {
                        var n = this.state.incidents;
                        n[i].collapsed = !n[i].collapsed;
                        this.setState({incidents: n})
                      }} aria-expanded='true' title='Traffic Condition: Good'>
                      <div className='panel-title'>
                        <span className={this.severityClass(incident)} aria-hidden='true'>
                          <span className='sr-only'>Alert</span>
                        </span>
                        <span className='traffic-route'>{incident.shortDescription}</span>
                      </div>
                    </button>
                    <div className={'panel-collapse collapse ' + (
                        incident.collapsed
                        ? ''
                        : 'in')} role='tabpanel'>
                      <div className='panel-body'>
                        <dl className='traffic-times-list'>
                          <dt className='term'>Delay</dt>
                          <dd className='definition'>{incident.delay}
                            min</dd>
                          <dt className='term'>Details</dt>
                          <dd className='definition'>
                            <p className='details'>{incident.description}</p>
                          </dd>
                        </dl>
                      </div>
                    </div>
                  </div>)
                })
              }

            </div>
          </section>
          <section role='tabpanel' className={'tab-pane  ' + (
              this.state.currentTab === 'Construction'
              ? 'fade in active'
              : '')}>

            <div className='panel-group' role='tablist' aria-multiselectable='true'>
              {
                this.state.construction.map((c, i, a) => {
                  return (<div className='panel panel-default' key={i}>
                    <button tabIndex='0' type='button' className={'panel-heading accordion-toggle ' + (
                        c.collapsed
                        ? 'collapsed'
                        : '')} role='tab' onClick={() => {
                        var n = this.state.construction;
                        n[i].collapsed = !n[i].collapsed;
                        this.setState({construction: n})
                      }} aria-expanded='false' title='Traffic Condition: Caution'>
                      <div className='panel-title'>
                        <span className={this.severityClass(c)} aria-hidden='true'>
                          <span className='sr-only'>Alert</span>
                        </span>
                        <span className='traffic-route'>{c.shortDescription}</span>
                      </div>
                    </button>
                    <div className={'panel-collapse collapse ' + (
                        c.collapsed
                        ? ''
                        : 'in')} role='tabpanel'>
                      <div className='panel-body'>
                        <dl className='traffic-times-list'>
                          <dt className='term'>Delay</dt>
                          <dd className='definition'>{c.end}</dd>
                          <dt className='term'>Information</dt>
                          <dd className='definition'>
                            <p className='details'>{c.description}</p>
                          </dd>
                        </dl>
                      </div>
                    </div>
                  </div>)
                })
              }
            </div>
          </section>
        </div>
      </div>

    </div>)
  }
}

export default TrafficPage



// WEBPACK FOOTER //
// ./app/components/custom/ssr/TrafficPage/index.js